export default {
      id: "search-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#search",
      toString: function () {
        return this.url;
      }
    }